import { z } from "zod";

/**
 * Add Experience Form Validation Schema
 * ------------------------------------------------------------
 * All fields are required.
 *
 * Fields:
 * - tenant
 * - campaign
 * - experienceName
 * - description
 */
export const addExperienceSchema = z.object({
  tenant: z.string().trim().min(1, "Tenant is required"),

  campaign: z.string().trim().min(1, "Campaign is required"),

  name: z.string().trim().min(1, "Experience name is required"),

  description: z
    .string()
    .trim()
    .min(1, "Description is required")
    .max(125, "Description cannot exceed 125 characters"),
});
